angular
    .module('app')
    .component('schoolsAdd', {
        templateUrl: '/templates/pages/schools/schoolsAdd/schoolsAdd.html',
        controller: 'SchoolsAddController',
        controllerAs: 'vm',
    });